import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import Box            from '@mui/material/Box';
import Grid           from '@mui/material/Grid';
import Typography     from '@mui/material/Typography';
import Button         from '@mui/material/Button';
import { useTheme }   from '@mui/material/styles';
import TextField      from '@mui/material/TextField';
import Checkbox       from '@mui/material/Checkbox';
import LocationOnIcon from '@mui/icons-material/LocationOn';

import Autocomplete from 'components/Api/Autocomplete';

function SearchBar({ query, address, remote, onChange, onPlaceSelect, search, locale }) {

  const theme = useTheme();

  const selectPlace = useCallback((value) => {
    if (!value) {
      onPlaceSelect({});
      return
    }

    onPlaceSelect(value);
  }, [onPlaceSelect]);

  const toggleRemote = useCallback((event) => {
    onChange('remote', event.target.checked)
  }, [onChange]);

  const onQueryChange = useCallback((event) => {
    onChange('query', event.target.value);
  }, [onChange]);

  return (
    <Grid container spacing={2} columns={12}>
      <Grid item md={5} xs={12}>
        <Grid container spacing={1} columns={3} direction="column">
          <Grid item xs={1}>
            <Typography variant="p" sx={{ fontWeight: 'bold' }}>{t('eos.company.listings.page.input.keywords')}</Typography>
          </Grid>
          <Grid item xs={1}>
            <TextField sx={{ width: '100%' }} inputProps={{ maxLength: 60 }} defaultValue={query} onChange={onQueryChange} variant="standard" data-testid="query-input"/>
          </Grid>
          <Grid item xs={1}></Grid>
        </Grid>
      </Grid>

      <Grid item md={5} xs={12}>
        <Grid container spacing={1} columns={3} direction="column">
          <Grid item xs={1}>
            <Typography variant="p" sx={{ fontWeight: 'bold' }}>{t('eos.company.listings.page.input.location')}</Typography>
          </Grid>
          <Grid item xs={1}>
            <Box sx={{ display: 'flex' }}>
              <Box sx={{ display: 'flex', pt: 1, pr: 1 }}>
                <LocationOnIcon fontSize="small" sx={{ color: theme.palette.grey['600'] }} />
              </Box>
              <Box sx={{ display: 'flex',  width: '90%' }} data-testid="location-input">
                <Autocomplete name="address" onPlaceSelect={selectPlace} variant="standard" value={address} locale={locale} />
              </Box>
            </Box>
          </Grid>
          <Grid item xs={1}>
            <Checkbox sx={{ p: 0, m: 0 }} label="Remote" checked={remote} onChange={toggleRemote} data-testid="remote-checkbox" />
            <Typography variant="p" sx={{ pl: 1, mt: 1 }}>{t('eos.company.listings.page.input.remote')}</Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} md={1} sx={{ display: 'flex', alignContent: 'center', flexDirection: 'row', alignItems: 'center' }}>
        <Box item sx={{ pb: 1 }}>
          <Button variant="contained" color="primary" onClick={search} data-testid="search-button">{t('eos.company.listings.page.button.search')}</Button>
        </Box>
      </Grid>
    </Grid>
  );
}

SearchBar.defaultProps = {
  query:    null,
  address:  null,
  remote:   false,
  onChange: null,
  search:   null,
  locale:   'en',
};

SearchBar.propTypes = {
  query:    PropTypes.string,
  address:  PropTypes.string,
  remote:   PropTypes.bool,
  onChange: PropTypes.func,
  search:   PropTypes.func,
  locale:   PropTypes.string,
};

export default SearchBar;
